"use client";

import React from "react";
import { ArrowRight, CircleCheck, Users, Star, Target } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const audience = {
  title: "Hospitality Owners",
  description: "Elevate your guest experience and operational efficiency. We implement high-end strategies that transform boutique hotels into market leaders.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679277/img/haven_luxury_hotel_lobby.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679277/img/haven_luxury_hotel_lobby.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679277/img/haven_luxury_hotel_lobby.png-wvc-sizes",
    alt: "Luxury hotel lobby with premium lighting and modern furniture"
  },
  link: "/InsightsPage"
};
const features = [{
  text: "Ondernemend"
}, {
  text: "Resultaatgericht"
}, {
  text: "Revenue Growth"
}, {
  text: "Guest Experience"
}];
const stats = [{
  icon: Users,
  text: "7+ specialists"
}, {
  icon: Star,
  text: "4 expertises"
}, {
  icon: Target,
  text: "1 doel"
}];
export default function TwoPerspectives() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}